import React from 'react';

export const RecreationalBuilding = () => (
  <g id="Group_1277" transform="translate(2367.482 -15510.684)">
    <path
      id="Path_3462"
      fill="#FFFFFF"
      d="M-1314,16024.2l-513.3-403.3l-513.3,403.3l59,69.1l88.3-69.1v255.5h-88.3v92.9h88.3v107.9h79.1
		l11.7-107.9h556.4v107.9h98.8v-94.6l82.8-13.3v-92.9l-82.8-10.6v-244.9l82.8,69.1L-1314,16024.2z"
    />
    <path id="Path" fill="#C3CDD9" d="M-2033.8,16271.3V15977h176.8v294.4" />
    <rect x="-2206.1" y="16247.6" fill="#C3CDD9" width="757.6" height="47.4" />
    <path
      fill="#172C4A"
      d="M-1447.2,16507.1h-93.8c-14.7,0-26.5-11.9-26.5-26.5v-87.3h-509.6v87.3c0,14.7-11.9,26.5-26.5,26.5h-89.5
		c-14.7,0-26.5-11.9-26.5-26.5v-85.3l-62.7-2.1c-14.3-0.5-25.6-12.2-25.6-26.5v-89.1c0-14.7,11.9-26.5,26.5-26.5h61.8v-172.4
		l-45.4,35.5c-11.2,8.8-27.3,7.1-36.5-3.6l-59-69.1c-4.7-5.5-6.9-12.7-6.2-19.9c0.7-7.2,4.3-13.8,10-18.2l513.3-403.3
		c9.6-7.6,23.2-7.6,32.8,0l513.3,403.3c11.2,8.8,13.5,25,5,36.5l-50.4,69c-4.3,5.9-10.9,9.8-18.2,10.7c-7.3,0.9-14.6-1.3-20.2-6
		l-39.3-32.8v170.2h56.3c14.7,0,26.5,11.9,26.5,26.5v92c0,14.7-11.9,26.5-26.5,26.5h-56.3v84.4
		C-1420.7,16495.3-1432.6,16507.1-1447.2,16507.1z M-1514.5,16454.1h40.7v-84.4c0-14.7,11.9-26.5,26.5-26.5h56.3v-39h-56.3
		c-14.7,0-26.5-11.9-26.5-26.5v-253.4c0-10.3,6-19.7,15.3-24c9.3-4.3,20.3-2.9,28.2,3.6l61.1,50.9l18.6-25.5l-476.8-374.6
		l-475.1,373.4l24.6,28.7l68.3-53.4c8-6.3,18.9-7.4,28-2.9c9.1,4.4,14.9,13.7,14.9,23.8v253.4c0,14.7-11.9,26.5-26.5,26.5h-61.8
		v36.9l62.7,2.1c14.3,0.5,25.6,12.2,25.6,26.5v84.4h36.4v-87.3c0-14.7,11.9-26.5,26.5-26.5h562.7c14.7,0,26.5,11.9,26.5,26.5
		V16454.1z"
    />
    <circle
      id="Ellipse_245"
      fill="#C3CDD9"
      cx="-1675.7"
      cy="16074.2"
      r="94.8"
    />
  </g>
);
